!
<template>
    <div>
        <config-main-title> Configurações de Serviços PACS </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-6">
                <az-input icon="fas fa-search" v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn"
                        :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn"
                        :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir_configuracao_servico_pacs()">
                    Incluir
                </button>
            </div>
        </div>

        <div v-if="lista && lista_filtrada.length > 0">
            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item" v-for="(configuracao, id) in lista_filtrada" :key="id">
                    <div class="d-flex justify-content-between">
                        <span class="h5 card-link mb-0 mr-3">
                            <a href="#" @click.prevent="editar_configuracao_servico_pacs(configuracao)">
                                {{ configuracao.search }}
                            </a>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" :id="'categoria-' + id"
                                    v-model="configuracao.fl_ativo" @change="alternar_status(configuracao)" />
                                <label class="custom-control-label" :for="'categoria-' + id"></label>
                            </div>
                        </span>
                    </div>
                </li>
            </div>
        </div>

        <div v-else>
            <az-empty-state msg="Nenhum Serviço PACS Configurado..." icon="fas fa-x-ray" />
        </div>

        <div class="modal fade" id="modalConfiguracaoServicoPacs" tabindex="-1" role="dialog"
            aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Configurações do Serviço
                            <span class="badge badge-secondary ml-2" v-if="item.id_configuracao_pacs">#{{
                                item.id_configuracao_pacs }}</span>
                            <span class="badge badge-secondary ml-2" v-else>Nova</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input label="Título" required placeholder="Título da configuração..."
                                    :validate="validate" v-model="item.st_titulo">
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-6">
                                <AzInput label="Serviço Pacs" type="select" placeholder="Selecione..."
                                    :optionsList="servicos_pacs" optionsData="name" optionsDisplay="name"
                                    :validate="validate" :edicao="!item.id_configuracao_pacs"
                                    v-model="item.js_configs.pacs" required />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input label="Unidade" type="select" placeholder="Todas as unidades..."
                                    optionsData="id_unidade_operacao"
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    v-model="item.id_unidade_operacao" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input label="Status de Imagens Disponíveis" type="select" placeholder="Selecione..."
                                    service="status_laudos.index" optionsMode="aql" optionsData="id_status_laudo"
                                    :validate="validate" v-model="item.js_configs.id_status_laudo" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12 col-md-6">
                                <az-input sizing="sm" type="checkbox-group" label="Enviar Anexos"
                                    v-model="item.fl_enviar_anexos" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input sizing="sm" type="checkbox-group" label="Enviar Laudo"
                                    v-model="item.fl_enviar_laudo" />
                            </div>
                        </div>

                        <div class="row mt-1">
                            <div class="col col-12 col-md-6">
                                <az-input sizing="sm" type="checkbox-group" label="Enviar Anamnese"
                                    v-model="item.fl_enviar_anamnese" />
                            </div>
                        </div>

                        <template v-if="
                            item.js_configs.pacs &&
                            carregar_campos_servico(item.js_configs.pacs).length > 0
                        ">
                            <az-sub-title title="Campos" class="mt-3" />
                            <div v-for="(campo, index) in carregar_campos_servico(item.js_configs.pacs)" :key="index">
                                <az-input v-if="campo == 'viewerId'" :label="campo" v-model="item.js_configs[campo]"
                                    :type="'select'" sizing="sm" class="mt-1" :optionsList="[
                                        { id: 'Logic_Web', search: 'Logic_Web' },
                                        { id: 'Logic_Web_Custom', search: 'Logic_Web_Custom' },
                                        { id: 'Logic_Desktop', search: 'Logic_Desktop' },
                                        { id: 'Osirix', search: 'Osirix' },
                                        { id: 'Horus', search: 'Horus' },
                                        { id: 'Radiant', search: 'Radiant' },
                                        { id: 'Weasis', search: 'Weasis' },
                                    ]" optionsData="id" />
                                <div class="mt-3" v-else-if="campo == 'configMedicos'">
                                    <az-sub-title title="Configurações de médicos">
                                        <a href="#" @click.prevent="incluir_config_medico()" class="card-link">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                            Configurações de médicos
                                        </a>
                                    </az-sub-title>
                                    <template v-for="(config, idx) in configs_medicos">
                                        <div class="form-row" :key="idx">
                                            <div class="col col-12 col-md-4">
                                                <az-input sizing="sm" type="autocomplete" placeholder="Selecione..."
                                                    optionsMode="aql" service="medicos.index"
                                                    optionsName="medicos-cadastro" :optionsParm="{ ativos: true }"
                                                    required v-model="config.id_medico">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend">
                                                            <button class="btn btn-outline-danger" type="button"
                                                                @click="remove_config_medico(idx)">
                                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-4">
                                                <az-input sizing="sm" type="text" placeholder="Usuário"
                                                    v-model="config.user" />
                                            </div>
                                            <div class="col col-12 col-md-4">
                                                <az-input sizing="sm" type="password" placeholder="Senha"
                                                    v-model="config.password" />
                                            </div>
                                        </div>
                                    </template>
                                    <a href="#" @click.prevent="incluir_config_medico()"
                                        class="btn btn-outline-primary btn-sm">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </a>
                                </div>
                                <template v-else-if="campo == 'url_report_hook' || campo == 'url_student_hook'">
                                    <template v-if="loadingWebhooksCadastrados">
                                        <az-input :label="campo" :edicao="false"
                                            :type="campo == 'producao' ? 'checkbox-group' : ''" sizing="sm"
                                            class="mt-1">
                                            <template v-slot:buttonposb>
                                                <button class="btn btn-sm" type="button" id="button-webhook-spinner"
                                                    title="Buscando informações...">
                                                    <i class="pi pi-spin pi-spinner"></i>
                                                </button>
                                            </template>
                                        </az-input>
                                    </template>
                                    <template v-else>
                                        <az-input :label="campo" :edicao="!webhooksCadastrados[campo]"
                                            v-model="item.js_configs[campo]"
                                            :type="campo == 'producao' ? 'checkbox-group' : ''" sizing="sm"
                                            class="mt-1">
                                            <template v-slot:buttonposb>
                                                <template v-if="webhooksCadastrados[campo]">
                                                    <button class="btn btn-danger btn-sm" type="button"
                                                        id="button-webhook-remove"
                                                        @click="update_webhook(campo, 'remove')" sizing="sm"
                                                        title="Remover webhook">
                                                        <i class="fa-solid fa-floppy-disk"></i>
                                                    </button>
                                                </template>
                                                <template v-else>
                                                    <button class="btn btn-success btn-sm" type="button"
                                                        id="button-webhook-create"
                                                        @click="update_webhook(campo, 'create')"
                                                        title="Persistir webhook">
                                                        <i class="fa-solid fa-floppy-disk"></i>
                                                    </button>
                                                </template>
                                            </template>
                                        </az-input>
                                    </template>
                                </template>
                                <template v-else-if="campo == 'configMedicoDefault'">
                                    <div style="display: flex; justify-content: space-between; align-items: center;">
                                        <az-input label="Medico padrão (quando não existir solicitante ou executante)"
                                            sizing="sm" type="autocomplete" placeholder="Selecione..." optionsMode="aql"
                                            service="medicos.index" optionsName="medicos-cadastro" style="width: 100%"
                                            optionsData="id_pessoa"
                                            v-model="item.js_configs[campo]" :optionsParm="{ ativos: true }" required>
                                        </az-input>
                                    </div>
                                </template>
                                <az-input v-else :label="campo" v-model="item.js_configs[campo]"
                                    :type="campo == 'producao' ? 'checkbox-group' : ''" sizing="sm" class="mt-1" />
                            </div>
                        </template>
                        <div class="mt-3">
                            <az-sub-title title="De-Paras">
                                <a href="#" @click.prevent="incluir_depara()" class="card-link">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                    Incluir De-Para
                                </a>
                            </az-sub-title>
                            <template v-for="(depara, idx) in item.deparas">
                                <div class="form-row" :key="idx" v-show="!depara.excluido">
                                    <div class="col col-12 col-md-3">
                                        <az-input sizing="sm" type="select" optionsMode="json"
                                            :optionsList="opcoes_depara" optionsData="id" :validate="validate" required
                                            :edicao="!depara.model_id" v-model="depara.model_type">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button"
                                                        @click="depara.excluido = true">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input sizing="sm" type="autocomplete" optionsMode="aql"
                                            :optionsSync="!infoFiltroModel(depara.model_type).nosync"
                                            :service="infoFiltroModel(depara.model_type).service" :optionsName="'filtro-' +
                                                depara.model_type +
                                                infoFiltroModel(depara.model_type).name
                                                " :optionsParm="{
                                                    ativos: true,
                                                    agenda: true,
                                                    ...infoFiltroModel(depara.model_type).parms,
                                                }" :edicao="depara.model_type && !depara.model_id ? true : false"
                                            placeholder="Selecione..." v-model="depara.model">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="depara.model_id">
                                                    <span class="input-group-text"> #{{ depara.model_id }} </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input sizing="sm" icon="fa-solid fa-code" placeholder="De-Para..."
                                            v-model="depara.st_id_externo" />
                                    </div>
                                </div>
                            </template>

                            <a href="#" @click.prevent="incluir_depara()" class="btn btn-outline-primary btn-sm">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </a>
                        </div>

                        <br /><br /><br /><br /><br /><br /><br /><br />
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="item.id_configuracao_pacs" model="configuracaoPacs"
                            :id="item.id_configuracao_pacs" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Fechar
                        </button>
                        <az-submit @click="atualizar()">{{
                            item.id_configuracao_pacs ? "Atualizar" : "Incluir"
                            }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import ConfigMainTitle from "../../cadastros/shared/ConfigMainTitle.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import AzSubTitle from "../../util/AzSubTitle.vue";
import AzAuditLogButton from "../../util/AzAuditLogButton.vue";

export default {
    components: {
        ConfigMainTitle,
        AzInput,
        AzSubmit,
        AzSubTitle,
        AzAuditLogButton,
    },

    data() {
        return {
            lista: [],
            servicos_pacs: [],
            search: "",
            viewMode: "A",
            item: null,
            validate: false,
            configs_medicos: [],
            webhooksCadastrados: {
                'url_report_hook': false,
                'url_student_hook': false
            },
            loadingWebhooksCadastrados: true
        };
    },

    computed: {
        opcoes_depara: function () {
            let opcoes = [
                {
                    id: "App\\azure\\local",
                    search: "Local",
                    service: "locals.index",
                    nosync: true,
                },
            ];

            return opcoes;
        },

        lista_filtrada: function () {
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(" ", ".*");
            let match = parts;
            let reg = new RegExp(match, "i");

            return this.lista.filter((item) => {
                return (
                    (item.fl_ativo || this.viewMode == "T") &&
                    (!this.search || reg.test(JSON.stringify(item)))
                );
            });
        }
    },

    methods: {
        incluir_depara() {
            this.item.deparas.push({
                model_type: "",
                model_id: "",
                st_id_externo: "",
                excluido: false,
            });
        },

        incluir_config_medico() {
            this.configs_medicos.push({
                id_medico: null,
                user: "",
                password: "",
            });
        },

        remove_config_medico(idx) {
            this.configs_medicos.splice(idx, 1);
        },

        infoFiltroModel(model) {
            if (!this.opcoes_depara || !model) return {};

            let opcao = this.opcoes_depara.find((item) => item.id == model);

            return opcao;
        },

        carregar() {
            this.$util.load(this, {
                service: "configuracao_pacs",
                parms: {
                    cadastro: true,
                },
                loadTo: (res) => {
                    this.lista = res;
                    if (this.item && this.item.js_configs) {
                        let query = {
                            q: [
                                {
                                    name: "pacs_configuracao.save_configs_medicos",
                                    id: "save_configs_medicos",
                                    parms: {
                                        configuracao_pacs_name: this.item.js_configs.pacs,
                                        configs_medicos: this.configs_medicos
                                    },
                                },
                            ],
                        };
                        this.axios.post("/aql", query);
                    }
                },
            });
        },

        abrir_modal(item) {
            this.item = item;

            if (this.item.id_configuracao_pacs && this.configs_medicos.length == 0) {
                let query = {
                    q: [
                        {
                            name: "pacs_configuracao.get_configs_medicos",
                            id: "get_configs_medicos",
                            parms: {
                                id_configuracao_pacs: this.item.id_configuracao_pacs,
                            },
                        },
                    ],
                };
                this.axios.post("/aql", query).then((res) => {
                    if (
                        res.data &&
                        res.data.get_configs_medicos &&
                        res.data.get_configs_medicos.data
                    ) {
                        const medicos = res.data.get_configs_medicos.data;
                        const configs = item.js_configs;

                        for (const [key,] of Object.entries(configs)) {
                            console.log(key);

                            if (key == 'url_report_hook' || key == 'url_student_hook') {
                                this.webhooks_cadastrados(key);
                            }
                        }
                        if (medicos) {
                            medicos.forEach((medico) => {
                                this.configs_medicos.push({
                                    id_medico: medico.id_medico,
                                    user: medico.st_usuario,
                                    password: medico.st_senha,
                                });
                            });
                        }
                    }
                })
            }

            this.$util.load(this, {
                service: "pacs_configuracao",
                loadTo: (res) => {
                    this.servicos_pacs = res;
                    $("#modalConfiguracaoServicoPacs").modal("show");
                },
            });
        },

        incluir_configuracao_servico_pacs() {
            let item = null;
            this.$nextTick(() => {
                item = {
                    st_titulo: "",
                    fl_ativo: true,
                    id_unidade_operacao: "",
                    js_configs: {
                        id_pacs_service: "",
                        id_status_laudo: "",
                    },
                };
                this.loadingWebhooksCadastrados = false;
                this.webhooksCadastrados = {
                    'url_report_hook': false,
                    'url_student_hook': false
                };
                this.abrir_modal(item);
            });
        },

        editar_configuracao_servico_pacs(configuracao) {
            this.abrir_modal(configuracao);
        },

        alternar_status(configuracao) {
            this.$util.toggle(this, {
                service: "configuracao_pacs",
                dados: configuracao,
            });
        },

        carregar_campos_servico(nome) {
            const servico = this.servicos_pacs.find((servico) => servico.name == nome);

            if (servico && servico.js_configs) {
                return servico.js_configs;
            }

            return [];
        },

        atualizar() {
            this.$util.atualizar(this, {
                service: "configuracao_pacs",
                dados: this.item,
                modal: "modalConfiguracaoServicoPacs",
                callback: () => {
                    this.carregar();
                },
            });
        },

        update_webhook(campo, type) {
            this.loadingWebhooksCadastrados = true;

            let query = {
                q: [
                    {
                        name: "drtis.webhook",
                        parms: {
                            item: this.item,
                            campo: campo,
                            type: type,
                        },
                    },
                ],
            };

            this.axios
                .post("aql", query)
                .then((res) => {
                    if (res.data && res.data["drtis.webhook"]) {
                        const response = res.data["drtis.webhook"];
                        if (response.status == 200) {
                            const aux = (type == 'remove' ? 'remover' : 'cadastrar');
                            this.$toast.add({
                                severity: "success",
                                summary: "Atualização",
                                detail: "Sucesso ao " + aux + " o webhook: " + campo,
                                life: 5000,
                            });
                        } else {
                            this.$toast.add({
                                severity: "error",
                                summary: "Erro no cadastro",
                                detail:
                                    "Erro ao cadastrar webhook: " + campo + " - Erro: " + res.data.message,
                                life: 5000,
                            });
                        }
                        this.loadingWebhooksCadastrados = false;
                    }
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                    $("#modalConfiguracaoServicoPacs").modal("hide");
                    this.carregar();
                });
        },

        webhooks_cadastrados(campo) {
            this.loadingWebhooksCadastrados = true;

            let query = {
                q: [
                    {
                        name: "drtis.webhook.cadastrado",
                        parms: {
                            item: this.item,
                            campo: campo,
                        },
                    },
                ],
            };

            this.axios.post("aql", query).then((response) => {
                const original = response && response.data
                    && response.data["drtis.webhook.cadastrado"]
                    && response.data["drtis.webhook.cadastrado"].data
                    && response.data["drtis.webhook.cadastrado"].data.original
                    && response.data["drtis.webhook.cadastrado"].data.original.original;

                this.$set(this.webhooksCadastrados, campo, original.status == 200);

                if (original.status == 404) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Não cadastrado",
                        detail: original.message,
                        life: 5000
                    });
                }
            }).finally(() => this.loadingWebhooksCadastrados = false);
        },
    },

    mounted() {
        this.carregar();

        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros" },
            { name: "Configurações de Serviços Pacs", path: "" },
        ];

        this.$store.commit("setBreadcrumb", this.breadcrumb);
    },
};
</script>
<style></style>
